import { memo, FC } from 'react'
import {
  // Select,
  InputGroup,
  // InputLeftAddon,
  Input,
} from '@chakra-ui/react'
import { DynamicFieldProps } from '../..'

const InputFilterField: FC<DynamicFieldProps> = ({
  register,
  name,
}) => {
  return (
    <InputGroup width="100%" minWidth="min-content">
      {/* <InputLeftAddon p={0} width="max-content">
        <Select placeholder="Selecione uma regra" {...register(`${name}_rule`)} roundedRight="none">
          <option value="HAVE">Contém</option>
          <option value="NOT_HAVE">Não contém</option>
        </Select>
      </InputLeftAddon> */}

      <Input {...register(name)} />
    </InputGroup>
  )
}

export default memo(InputFilterField)
